module.exports = __webpack_public_path__ + "static/media/evaluation.2d0015f3.svg";